<template>
    <div>
        <div class="p-4">
            <h2>Gerenciar turmas e aulas</h2>
            <p>Crie turmas, gerencie seus estudantes e aulas</p>

            <div class="flex justify-content-end mb-4">
                <Button label="Adicionar Turma" size="small" @click="visible = true" />
                <Button label="Excluir Turma" icon="pi pi-trash" severity="danger" size="small" class="ml-3"
                    :disabled="turmasSelecionadas.length == 0" @click="excluirTurmas" />
            </div>
            <Toast />
            <Dialog v-model:visible="visible" modal header="Adicionar Turma" :style="{ width: '50vw' }"
                :breakpoints="{ '960px': '75vw', '641px': '95vw' }">
                <form @submit.prevent="inserirTurma">

                    <InputText type="text" v-model="novaTurma.nome" placeholder="Nome da Turma" class="w-full mb-3 mt-1"
                        required />

                    <Dropdown :options="anos" optionLabel="label" optionValue="value" placeholder="Ano da Turma"
                        v-model="novaTurma.ano" class="w-full mb-3" required />

                    <Button :loading="loading" label="Adicionar " size="small" type="submit" />
                </form>
            </Dialog>
        </div>

        <DataTable v-if="turmas.length > 0"  v-model:selection="turmasSelecionadas" v-model:editingRows="editingRows" :value="turmas" paginator
            :rows="50" v-model:filters="filters" editMode="row" dataKey="id" @row-edit-save="onRowEditSave" stripedRows>
            <template #header>
                <div class="flex justify-content-end">
                    <span class="p-input-icon-left">
                        <i class="pi pi-search" />
                        <InputText v-model="filters['global'].value" placeholder="Pesquisar usuário" />
                    </span>

                </div>
            </template>
            <Column selectionMode="multiple" headerStyle="width: 3rem"></Column>


            <Column field="ano" header="Ano" sortable>
                <template #body="slotProps">
                    {{ valorParaAno(slotProps.data.ano) }}
                </template>
                <template #editor="{ data, field }">

                    <Dropdown v-model="data[field]" :options="anos" optionLabel="label" optionValue="value" autofocus
                        size="small" class="w-full" />
                </template>
            </Column>

            <Column field="nome" header="Nome" sortable>
                <template #body="slotProps">
                    {{ slotProps.data.nome }}
                </template>
                <template #editor="{ data, field }">
                    <InputText type="text" v-model="data[field]" placeholder="Nome da Turma" />

                </template>
            </Column>

            <Column field="id" header="Editar turmas" >
                    <template #body="slotProps">
                        <Button label="Editar turma" text size="small" @click="navigateToDetails(slotProps.data.id,slotProps.data.nome,slotProps.data.ano)" />
                    </template>
                </Column>

            <Column header="Editar" :rowEditor="true" style="width: 10%; min-width: 8rem" bodyStyle="text-align:center">
            </Column>
        </DataTable>
    </div>
</template>
<script setup>
import { ref, onMounted, onActivated } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex'
import { supabase } from '@/supabase';
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import { FilterMatchMode } from 'primevue/api';
import InputText from 'primevue/inputtext';
import Button from 'primevue/button';
import Dialog from 'primevue/dialog';
import Dropdown from 'primevue/dropdown';
import Avatar from 'primevue/avatar';
import Toast from 'primevue/toast';
import { useToast } from "primevue/usetoast";
import MultiSelect from 'primevue/multiselect';

const store = useStore()
const visible = ref(false)
const loading = ref(false)
const turmasSelecionadas = ref([])
const turmas = ref([])

const filters = ref({ global: { value: null, matchMode: FilterMatchMode.CONTAINS } })
const editingRows = ref([])
const anos = ref([
    { label: "1° ano", value: "1" },
    { label: "2° ano", value: "2" },
    { label: "3° ano", value: "3" }
])
const novaTurma = ref({ nome: '', ano: "" })
const router = useRouter();

const navigateToDetails = (id, nome, ano) => {
    router.push({ name: 'turmaDetalhe', params: { id }, query: {nome, ano } });
};


onMounted(() => {
    listarTurmas()

});



const testando = (data) => {
    console.log('testando')
    console.log(data)

}
const toast = useToast();
const showToastAddTurma = () => {
    let texto = ` A turma ${novaTurma.value.nome} foi adicionada com sucesso`
    toast.add({ severity: 'success', summary: 'Curso', detail: texto, life: 3000 });
};
const showToastErrorTurma = () => {
    toast.add({ severity: "error", summary: 'Curso', detail: 'Ocorreu um erro ao carregar os dados', life: 3000 });
};

const excluirCursos = async () => {
    console.log('curso excluído')
}
const inserirTurma = async () => {
    loading.value = true
    const { data, error } = await supabase
        .from('turmas')
        .insert(novaTurma.value)
        .select()
    if (error) { showToastErrorCurso(); loading.value = false; return }
    showToastAddTurma()
    loading.value = false
    novaTurma.value = { nome: '', ano: '' }
    listarTurmas()
}

const listarTurmas = async () => {
    const { data, error } = await supabase
        .from('turmas')
        .select('*')
        .order('ano, nome')
    turmas.value = data
}

const onRowEditSave = async (event) => {
    let { newData } = event;
    console.log(newData)
    loading.value = true;
    const { error, data } = await supabase
        .from('turmas')
        .update(newData)
        .eq('id', newData.id)
        .select()
    if (error) { showToastErrorTurma(); loading.value = false; return }
    listarTurmas()
    loading.value = false


}

const excluirTurmas = async () => {
    store.dispatch('updateLoading',true)
    let itensParaDeletar = []
    turmasSelecionadas.value.forEach(item => itensParaDeletar.push(item.id))

    const { error } = await supabase
        .from('turmas')
        .delete()
        .in('id', itensParaDeletar)
    
    turmasSelecionadas.value = []
    store.dispatch('updateLoading',false)
    listarTurmas()

}

const valorParaAno = (ano) => {
    switch (ano) {
        case "1":
            return "1° ano"
            break;
        case "2":
            return "2° ano"
            break
        case "3":
            return "3° ano"
            break
        default: "Sem ano"
            break;
    }
}


</script>